import React from 'react';
import { Layout, Menu, Col, Button, Modal } from 'antd';

import ImageComponent from '@sharedComponent/image-component';
import { images } from '@assets/img';
import SpanComponent from '@sharedComponent/span-component';
import { HomeRoutes } from '@routes';
import { Link } from 'react-router-dom';
import { BackwardOutlined, PoweroffOutlined } from '@ant-design/icons';

const { Content, Sider } = Layout;

const HomePresentational = ({
	menuRoutes,
	handleMenuClick,
	handleCollapsed,
	collapsed,
	confirmLogoutVisible,
	handleLogoutModel,
	handleLogout,
	handleGoback,
	activeMenu,
	selectedKeys,
	selectedRoute,
}) => {
	return (
		<Layout style={{ minHeight: '100vh' }}>
			<Sider className="k_sidebar" collapsed={collapsed}>
				<Menu theme="light" selectedKeys={selectedRoute()} mode="inline">
					<Col className="sidebar_Logo_Area" onClick={() => handleMenuClick('/dashboard')} style={{ cursor: 'pointer' }}>
						<Col className="image_area">
							<Link to="/dashboard">
								{/* <ImageComponent src={images.konnektivelogo} /> */}
								<ImageComponent src={images.LOGO_and_NAME} />
							</Link>
						</Col>
						<Col className="image_area_collapse">
							<Link to="/dashboard">
								{/* <ImageComponent src={images.k} /> */}
								<ImageComponent src={images.JUST_LOGO} />
							</Link>
						</Col>
					</Col>
					<Col className="toggle_area">
						<Col className="imges" onClick={handleCollapsed}>
							<ImageComponent src={images.collapseleft} />
						</Col>
					</Col>
					{menuRoutes.map((menu, i) => (
						<Menu.Item
							key={menu.route}
							onClick={() => handleMenuClick(menu.route)}
							icon={
								<SpanComponent className="anticon">
									<ImageComponent className="menu_icon " src={menu.icon} />
								</SpanComponent>
							}>
							{menu.name}
						</Menu.Item>
					))}
					<Col className="sidebar_last">
						<Col className="reactAngle">
							<BackwardOutlined onClick={handleGoback} />
						</Col>
						<Col className="sidebar_bottom">
							<Col className="gobackbtnarea">
								<Button className="goback_btn" htmlType="submit" onClick={handleGoback}>
									Go Back
								</Button>
							</Col>
						</Col>
						<Col className="reactAngle">
							<PoweroffOutlined onClick={handleLogout} />
						</Col>
						<Col className="sidebar_bottom">
							<Col className="logimg">
								<ImageComponent className="logoutimg" src={images.logout} />
							</Col>
							<Col className="logoutbtnarea">
								<Button className="logout_btn" htmlType="submit" onClick={handleLogout}>
									Logout
								</Button>
							</Col>
						</Col>
					</Col>
					<Modal visible={confirmLogoutVisible} title={null} centered={true} footer={null} closable={false} className="delete_modal_area">
						<Col className="delete_modal_body">
							<Col style={{ textAlign: 'center', marginBottom: '20px', marginTop: '20px' }}>
								<ImageComponent style={{ maxWidth: '250px' }} src={images.signout} />
							</Col>
							<Col className="delete_modal_body_content">Are you sure that you want to sign out?</Col>
						</Col>
						<Col className="delete_modal_footer">
							<Button className="cancel_btn" onClick={() => handleLogoutModel(false)}>
								No
							</Button>
							<Button className="delete_btn" onClick={() => handleLogoutModel(false, 'logout')}>
								Yes
							</Button>
						</Col>
					</Modal>
				</Menu>
			</Sider>
			<Layout className="site-layout">
				<Content style={{ margin: '0 30px' }}>
					<HomeRoutes />
				</Content>
			</Layout>
		</Layout>
	);
};

export default HomePresentational;
